import { action, computed, makeObservable, observable } from "mobx";
import { forEach } from "lodash";

class NakiNigunArtist {
    @observable _numberOfEnabledAlbums = 0;
    @observable _manuallyEnabled = true;

    constructor(obj) {
        makeObservable(this);
        forEach(obj, (value, key) => {
            if (key === "numberOfEnabledAlbums") {
                this.setNumberOfEnabledAlbums(value);
            } else if (key === "isTurnedOn") {
                this.setManuallyEnabled(value);
            } else {
                this[key] = value;
            }
        });
    }

    @computed get numberOfEnabledAlbums() {
        return this._numberOfEnabledAlbums;
    }

    @computed get isTurnedOn() {
        return this._manuallyEnabled;
    }

    set isTurnedOn(value) {
        this.setManuallyEnabled(value);
        if (value) {
            this.setNumberOfEnabledAlbums(this.numberOfAlbums);
        } else {
            this.setNumberOfEnabledAlbums(0);
        }
    }

    @action.bound
    setManuallyEnabled(value) {
        this._manuallyEnabled = value;
    }

    @action.bound
    setNumberOfEnabledAlbums(value) {
        this._numberOfEnabledAlbums = value;
    }
}

export default NakiNigunArtist;
